export default __webpack_public_path__ + "static/media/java.f1064f7c.png";